import { render, staticRenderFns } from "./Correspondents.vue?vue&type=template&id=7174247a&scoped=true&"
import script from "./Correspondents.vue?vue&type=script&lang=js&"
export * from "./Correspondents.vue?vue&type=script&lang=js&"
import style0 from "./Correspondents.vue?vue&type=style&index=0&id=7174247a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7174247a",
  null
  
)

export default component.exports